import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { RespondWorkflowListModel, WtfActionReassignToInputModel } from 'src/app/ViewModel/RespondWorkflowModel';
import { CreateTransmittalComponent } from '../transmittal-creation/transmittal-creation.component';
import { WorkflowActionModel } from 'src/app/ViewModel/WorkflowActionModel';
import { WorkflowTemplateDialogModel } from 'src/app/ViewModel/WorkflowTemplateDialogModel';
import * as moment from 'moment';
import { formatDate } from '@angular/common';
import { DelayreasonComponent } from '../delay-reason/delayreason/delayreason.component';
import { ILatestStageDetails } from 'src/app/ViewModel/ScheduleDocumentModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { forkJoin, Observable } from 'rxjs';
import { WtfActionReassigntoDtnComponent } from '../../workflow/dialogs/wtf-action-reassignto-dtn/wtf-action-reassignto-dtn.component';
import { WorkflowTemplateStatusInputModel } from 'src/app/ViewModel/WorkflowTemplateStatusInputModel';
import { WorkflowAssignedToModel } from 'src/app/ViewModel/WorkflowAssignedToModel';

@Component({
  selector: 'app-bulkdtn',
  templateUrl: './bulkdtn.component.html',
  styleUrls: ['./bulkdtn.component.css']
})
export class BulkDTNComponent implements OnInit {
  public gridData: any[] = [];
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public isDTNPrepared: boolean = false;
  public currentWorkflowDetails!: WorkflowTemplateDialogModel;
  public workflowActions: WorkflowActionModel[] = [];
  public approveActionDetails: WorkflowActionModel[] = [];
  public delayReasonList: any[] = [];
  public internalReasonList: any[] = [];
  public externalReasonList: any[] = [];
  public selectedCmdType!: string;
  public dueOn: any;
  public comments!: string;
  public enableFilter = false;
  public LatestStageDetails: ILatestStageDetails[] = [];
  public enableFullscreen: boolean = false;
  public docNextStepDetails:Observable<StandardOutputModel>[]=[];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<BulkDTNComponent>,
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public workflowTemplateService: WorkflowTemplateService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();

    this.delayReasonList = [{ id: 1, commentType: "Internal Reason" }, { id: 2, commentType: "External Reason" }, { id: 3, commentType: "Other" }];

    this.internalReasonList = [{ id: 1, IntrcommentType: "Multi disciplinary coordination" }, { id: 2, IntrcommentType: "Non availability of staff" },
    { id: 3, IntrcommentType: "Delay in interface input" }, { id: 4, IntrcommentType: "Delay in Internal review" }, { id: 5, IntrcommentType: "Delayed approval from ECD" },
    { id: 6, IntrcommentType: "Hardware Issues – Printer / Plotter" }, { id: 7, IntrcommentType: "Wrongly entered schedule date" },
    { id: 8, IntrcommentType: "Drawing released through manual transmittal" }, { id: 9, IntrcommentType: "Drawing revised during workflow in progress" }];

    this.externalReasonList = [{ id: 1, ExtrcommentType: "Delay in Client Input" }, { id: 2, ExtrcommentType: "Delay in Vendor Input" },
    { id: 3, ExtrcommentType: "Delayed approval from Client / Consultant" }, { id: 4, ExtrcommentType: "Delayed receipt of vendor clearance / approval" }];

    this.filterDocuments();
  }

  public filterDocuments() {
    this.gridData = [];
    this.gridData = this.data.selectedList;
    this.gridData.forEach(x => x.isSelected = false);

    this.gridData.forEach(data => {
      data.comments = '';
      data.delayReason = '';
      data.internalReason = '';
      data.externalReason = '';
    })

    this.isDTNPrepared = false;
    this.workflowTemplateService.getWorkflowTemplate(this.gridData[0].workflowId).subscribe((data: WorkflowTemplateDialogModel) => {
      this.currentWorkflowDetails = data;

      this.workflowActions = this.currentWorkflowDetails.workflowAction.filter(x => x.task_Id == this.gridData[0].currentTaskId);
      this.approveActionDetails = this.workflowActions.filter(item => item.action_Description == 'Approve');
    }, err => { this.notificationService.showToast(err, "Error"); });
  }

  isEnable() {
    let selectedList: any[] = [];

    this.gridData.filter(x => x.isSelected).forEach(y => {
      selectedList.push(y);
    });

    return selectedList.length >= 1 && !this.isDTNPrepared ? true : false;
  }

  dtnPreparation() {
    let selectedList: any[] = [];

    this.gridData.filter(x => x.isSelected).forEach(y => {
      selectedList.push(y);
    });

    if (selectedList.length == 0) {
      this.notificationService.showToast("Please select atleast one document to prepare DTN", "Warning");
      return;
    }

    this.isDTNPrepared = true;
    let recivedData: any;

    selectedList.forEach(data => {
      this.dueOn = data.revisedScheduled_On ? data.revisedScheduled_On : data.scheduledOn;
      let dueOnDate = formatDate(this.dueOn, 'yyyy-MM-dd', 'en-US');
      let today = formatDate(new Date(), "yyyy-MM-dd", 'en-US');
      if (today > dueOnDate) {
        data["isDelayed"] = true;
      }
      else {
        data["isDelayed"] = false;
      }
    });

    let DelayDocList = selectedList.filter(value => value.isDelayed == true);
    if (DelayDocList.length > 0) {
      const dialogRef = this.dialog.open(DelayreasonComponent, {
        panelClass: 'mat-dialog-primary',
        data: DelayDocList,
      });
      dialogRef.afterClosed().subscribe((selectedArr: any[]) => {
        recivedData = selectedArr;
        selectedList.forEach(data => {
          selectedArr.forEach(element => {
            if (data.documentNumber == element.documentNumber) {
              data.selectedCom = element.selectedCom;
              data.selectedCmdType = element.selectedCmdType;
            }
          });
        })
        if (!!recivedData) {
          this.postDtn();
        }
      });
    } else {
      this.postDtn();
    }
  }

  postDtn() {
    let selectedList: any[] = [];
    let SendMailOnActionCompletionInputModel: any[] = [];

    this.gridData.filter(x => x.isSelected).forEach(y => {
      selectedList.push(y);
    });

    if (selectedList.length > 0) {
      let dialogRef = this.dialog.open(CreateTransmittalComponent, {
        panelClass: 'mat-dialog-primary',
        data: { selectedList: selectedList, inputType: 'dtnPreparation', WorkflowTemplateDetails: this.currentWorkflowDetails },
        autoFocus: false,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((data: any) => {
        if (data != null && data != undefined) {
          for (let i = 0; i < selectedList.length; i++) {
            let _respondWorkflowDetails: any = { "projectId": 0, "groupId": 0, respondWorkflowDetails: [], createdBy: 0, stageDetails: this.LatestStageDetails };
            let obj: any = {};
            obj["documentId"] = selectedList[i].documentId;
            obj["revisionNumber"] = selectedList[i].revisionNo;
            obj["workflowId"] = selectedList[i].workflowId;
            obj["TaskId"] = selectedList[i].currentTaskId;
            obj["assignType"] = selectedList[i].assignedType;
            obj["memberId"] = this.memberId;
            obj["actionPerformed"] = this.approveActionDetails[0].action_Id;
            obj["completedBy"] = this.memberId;
            obj["statusId"] = this.approveActionDetails[0].status_Id;
            obj["completedOn"] = null;
            obj["comments"] = "";
            obj["delayReason"] = selectedList[i].selectedCom == "Other" ? selectedList[i].selectedCmdType : null;
            obj["internalReason"] = selectedList[i].selectedCom == "Internal Reason" ? selectedList[i].selectedCmdType : null;
            obj["externalReason"] = selectedList[i].selectedCom == "External Reason" ? selectedList[i].selectedCmdType : null;
            obj["isFileAvailable"] = true;
            obj["taskSlNo"] = selectedList[i].taskSerialNumber;
            obj["commentSheetNo"] = data;
            _respondWorkflowDetails.projectId = selectedList[i].projectId;
            _respondWorkflowDetails.groupId = selectedList[i].groupId;
            _respondWorkflowDetails.createdBy = this.memberId;
            _respondWorkflowDetails.respondWorkflowDetails.push(obj);
            this.assignNextStep(_respondWorkflowDetails, this.approveActionDetails[0], selectedList[i]);

            SendMailOnActionCompletionInputModel.push({
              projectId: this.projectId,
              groupId: this.groupId,
              documentId: selectedList[i].documentId,
              documentRevision: selectedList[i].revisionNo,
              workflowId: selectedList[i].workflowId,
              createdBy: this.memberId,
              Doc_Title: selectedList[i].documentTitle,
              Doc_No: selectedList[i].documentNumber,
              toSendSingleMail: true
            });
          }

          if(this.docNextStepDetails && this.docNextStepDetails.length>0)
          {
            let workflowIdList = selectedList.map(x => x.workflowId);
            let workflowTemplateDetails:WorkflowTemplateDialogModel[]=[];
            if(workflowIdList.length==1)
            {
              workflowTemplateDetails.push(this.currentWorkflowDetails);
            }
            else if(workflowIdList.length>1)
            {
              workflowTemplateDetails.push(this.currentWorkflowDetails);
              workflowIdList = workflowIdList.filter(x => x!= this.currentWorkflowDetails.workflow_Id);
              if(workflowIdList && workflowIdList.length>0)
              {
                let uniqueWorkflowId = workflowIdList.filter((x,ind) => workflowIdList.indexOf(x)===ind).join(',');
                if(uniqueWorkflowId && uniqueWorkflowId.length>0)
                this.workflowTemplateService.getWorkflowTemplateDetails(uniqueWorkflowId).toPromise().then((res:WorkflowTemplateDialogModel[])=>{
                  res.forEach(async x => {
                    await workflowTemplateDetails.push(x);
                  })
                })
              }
            }
            
            forkJoin(this.docNextStepDetails).subscribe(res => {
              let successList:WtfActionReassignToInputModel[]=[];
              selectedList.forEach((x,index) => {
                if(!!res[index])
                {
                  let val=res[index];
                  if(val.successCode==200)
                  {
                    let isNextStepAva = Boolean(JSON.parse(val.result.toString().split(',')[0]));
                    let _nextStepId = parseInt(JSON.parse(val.result.toString().split(',')[1]));
                    let worklfowtemplate:WorkflowTemplateDialogModel = workflowTemplateDetails && workflowTemplateDetails.filter(temp => temp.workflow_Id==x.workflowId).length>0 ? workflowTemplateDetails.filter(temp => temp.workflow_Id==x.workflowId)[0]:null;
                    let isforReassigment = worklfowtemplate.isForReAssignment;
                    let stepDetail: WorkflowTemplateStatusInputModel = worklfowtemplate.workflowStatus.filter(x => x.step_Id == _nextStepId)[0];
                    let isSetpForReassignment = stepDetail ? stepDetail.is_Step_For_Reassignment : false; 
                    if(isNextStepAva && isforReassigment && isSetpForReassignment && !!stepDetail)
                    {
                      let nextStepAssignedToRoles: WorkflowAssignedToModel[] = worklfowtemplate.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type==1).filter(r => r.role_Id > 0);
                      let nextStepAssignedToMember: WorkflowAssignedToModel[] = worklfowtemplate.workflowAssignedTo.filter(x => x.task_Id == stepDetail.task_Id && x.assign_Type==1).filter(r => r.role_Id == 0 && r.member_Id>0);
                      if ((!!nextStepAssignedToRoles && nextStepAssignedToRoles.length > 0) || (!!nextStepAssignedToMember && nextStepAssignedToMember.length>0)) {
                        x['nextStepDetail']=stepDetail;
                        x['nextStepAssignedToRoles']=nextStepAssignedToRoles && nextStepAssignedToRoles.length>0 ? nextStepAssignedToRoles:null;
                        x['nextStepAssignedToMember']=nextStepAssignedToMember && nextStepAssignedToMember.length>0 ? nextStepAssignedToMember:null;
                        successList.push(x);
                      }
                    }
                  }
                }
              })
              if(successList && successList.length>0)
              {
                let dialogRef1=this.dialog.open(WtfActionReassigntoDtnComponent,{
                  panelClass: 'mat-dialog-primary',
                  data: {successList:successList,workflowTemplateDetails:workflowTemplateDetails},
                  width: '50%'
                })
                dialogRef1.afterClosed().subscribe(res => {
                  this.workflowTemplateService.BulkSendMailOnActionCompletion(SendMailOnActionCompletionInputModel).toPromise().then((_res: StandardOutputModel) => {
                    this.closeDialog();
                  });
                })
              }
            })
            
          }
          else
          {
            this.workflowTemplateService.BulkSendMailOnActionCompletion(SendMailOnActionCompletionInputModel).toPromise().then((_res: StandardOutputModel) => {
              this.closeDialog();
            });

          }
        
        }
        else {
          this.notificationService.showToast("Failed to create Transmittal", "Warning");
        }
      });
    }
  }

  public onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = false;
      });
    }
    this.isEnable();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public assignNextStep(_respondWorkflowDetails: any, _action: WorkflowActionModel, _doclist: RespondWorkflowListModel) {
    // this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails).toPromise().then(data => {
    //   if (!!data) {
    //     this.notificationService.showToast(data["successMessage"], "Success");
    //   }
    //   else {
    //     this.notificationService.showToast("Failed to Move Next Step", "Error");
    //   }
    // });
    this.docNextStepDetails.push(this.workflowTemplateService.postRespondWorkflowDetails(_respondWorkflowDetails));
  }

  public getFormattedDate(date) {
    if (date != null) {
      return (moment(date)).format('DD-MMM-yyyy');
    }
  }

  onHover(_input: any) {
    // TODO document why this method 'onHover' is empty

  }

  editRowData(_input: any) {
    // TODO document why this method 'editRowData' is empty
  }

  UpdateRowData(_input: any) {
    // TODO document why this method 'UpdateRowData' is empty
  }

  cancelRowData(_input: any) {
    // TODO document why this method 'cancelRowData' is empty
  }
}